import Image from 'next/image';
import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';

const ServiceAnimation1 = () => {
  const { ref, inView } = useInView({ threshold: 0.5, triggerOnce: true });

  return (
    <div ref={ref}>
      <motion.div
        className="absolute -left-[35px]"
        initial={{ opacity: 0, scale: 0 }}
        animate={
          inView
            ? {
                opacity: 1,
                scale: [0, 1],
                transition: { type: 'spring', delay: 0.3, duration: 0.5 },
              }
            : { opacity: 0, scale: 1 }
        }
      >
        <Image
          src="/images/e-signature/labtop.png"
          alt=""
          width={243}
          height={173}
          layout="fixed"
        />
      </motion.div>
      <motion.div
        className="absolute w-fit top-[22px] -left-[32px]"
        initial={{ opacity: 0, x: 11, y: -9 }}
        animate={
          inView ? { opacity: 1, x: 0, y: 0 } : { opacity: 0, x: 11, y: -9 }
        }
        transition={{ duration: 0.5, delay: 0.35, ease: 'easeIn' }}
      >
        <Image
          src="/images/e-signature/diagram.png"
          alt=""
          width={95}
          height={72}
          layout="fixed"
        />
      </motion.div>
      <motion.div
        className="absolute w-fit top-[17px] left-[76px]"
        initial={{ opacity: 0, scale: 0 }}
        animate={
          inView
            ? {
                opacity: 1,
                scale: [0, 1],
                transition: { type: 'spring', delay: 0.5, duration: 0.5 },
              }
            : { opacity: 0, scale: 1 }
        }
      >
        <Image
          src="/images/e-signature/cog.png"
          alt=""
          width={73}
          height={78}
          layout="fixed"
        />
      </motion.div>
      <motion.div
        className="absolute top-[84px] -right-[4px]"
        initial={{ opacity: 0, x: 30, y: 21 }}
        animate={
          inView ? { opacity: 1, x: 0, y: 0 } : { opacity: 0, x: 30, y: 21 }
        }
        transition={{ duration: 1, delay: 0.8 }}
      >
        <Image
          src="/images/e-signature/power.svg"
          alt=""
          width={72}
          height={82}
          layout="fixed"
        />
      </motion.div>
    </div>
  );
};

export default ServiceAnimation1;
